import styled from "styled-components";

export const Line = styled.line`
  stroke-width: 1.2px;
  stroke: var(--theme-neutral-200);
  cursor: pointer;
  &:hover {
    stroke: var(--theme-neutral-200);
    stroke-width: 1.5px;
  }
`;

export const Circle = styled.circle`
  transition: all 0.3s ease-in-out;
  fill: var(--mode-bg-neutral-weakest, #fff);
  filter: drop-shadow(0 0.1px 2px var(--mode-shadow-default));
`;

export const BoundLine = styled.line`
  transition: all 0.3s ease-in-out;
  stroke: var(--mode-bg-primary-weak, #6046ff);
  stroke-width: 14px;
  opacity: 0;
`;

export const Arrow = styled.g<{ $scaleUp: boolean }>`
  transform: ${({ $scaleUp }) =>
    $scaleUp ? "rotate(180deg)" : "rotate(0deg)"};
  fill: var(--mode-bg-primary-default, #6046ff);
`;

export const Group = styled.g`
  &:hover {
    line {
      stroke: var(--mode-bg-primary-default, #6046ff);
    }

    circle {
      r: 8px;
      fill: var(--mode-bg-primary-default, #6046ff);
    }

    .arrow {
      fill: var(--mode-bg-neutral-weakest, #fff);
    }

    .bound-line {
      opacity: 0.3;
    }
  }
`;
